export default __webpack_public_path__ + "static/media/spinner.22991752.svg";